import { render, staticRenderFns } from "./NavigationEdit.vue?vue&type=template&id=4f812ed6&scoped=true"
import script from "./NavigationEdit.vue?vue&type=script&lang=js"
export * from "./NavigationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f812ed6",
  null
  
)

export default component.exports